module.exports = __webpack_public_path__ + "static/media/pteronemobius_heydenii.7f81df62.jpg";